// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__Rt4f8","requiresAction":"styles_requiresAction__6vaTj","avatar":"styles_avatar__1E9hA","secondaryText":"styles_secondaryText__pnOHA"};